export const Url = process.env.REACT_APP_URL;
export const Url_Base = process.env.REACT_APP_URL_BASE;
export const ENV_SYSTEM = process.env.REACT_APP_SYSTEM;
export const UrlImage = process.env.REACT_APP_URL_IMAGE;
export const UrlLogout = process.env.REACT_APP_URL_POST_LOGOUT;
export const GA_TRACKING_CODE = process.env.REACT_APP_GA_TRACKING_CODE;
export const FACEBOOK_LINK=process.env.REACT_APP_FACEBOOK_LINK;
export const TWITTER_LINK=process.env.REACT_APP_TWITTER_LINK;
export const YOUTUBE_LINK=process.env.REACT_APP_YOUTUBE_LINK;
export const STORAGE_IMAGE_LINK=process.env.REACT_APP_STORAGE_IMAGE_LINK;
export const EMAIL_DOMAIN=process.env.REACT_APP_EMAIL_DOMAIN;
export const EXTERNAL_API_LINK=process.env.REACT_APP_EXTERNAL_API_LINK;